import { BehaviorSubject } from 'rxjs';

const virtualWeidgetModal$ = new BehaviorSubject(false);
const virtualWeidgetSportId$ = new BehaviorSubject(0);


const displayVirtualWeidgetModal = (isShow: boolean, sportId?: number) => {
	virtualWeidgetModal$.next(isShow);
	if (sportId) {
		virtualWeidgetSportId$.next(sportId);
	}
}


export const virtualWeidgetService = {
	onVirtualWeidgetModal$: virtualWeidgetModal$.asObservable(),
	virtualWeidgetSportId$: virtualWeidgetSportId$.asObservable(),
	displayVirtualWeidgetModal
};